export default [
  { name: 'sticker', label: 'SOS Sticker #', component: 'input' },
  { name: 'odometerStart', label: 'Odometer Start', component: 'input' },
  { name: 'odometerEnd', label: 'Odometer End', component: 'input' }
];
